import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { Country } from 'country-state-city'
import { ICountry } from 'country-state-city/lib/interface'
import { FC, useContext } from 'react'
import { COUNTRY_NAMES } from '../../utils/constants/country-name-translations'

import { OnboardingStepsFormType } from '../../utils/types/auth'
import './auth-country-selection.scss'
import { OnboardingFormContext } from '../../providers/contexts/OnboardingForm'

const SyndeoCountries = Object.values(
    (Country.getAllCountries() as ICountry[]).sort((item1, item2) =>
        item1.isoCode.localeCompare(item2.isoCode)
    )
)

type AuthCountrySelectionProps = {
    countrySelected?: ICountry
    handleChange: (event: SelectChangeEvent) => void
    values: OnboardingStepsFormType
}

const AuthCountrySelection: FC<AuthCountrySelectionProps> = ({
    countrySelected,
    handleChange,
    values,
}) => {
    const { multiAccount, unregisteredUserData } = useContext(
        OnboardingFormContext
    )

    return (
        <p className="syndeo-select-country-para">
            <Select
                className="select-country"
                name="language"
                placeholder="Language"
                value={countrySelected?.isoCode?.toLowerCase() ?? ''}
                autoWidth
                variant="standard"
                onChange={handleChange}
                renderValue={(selected) =>
                    selected?.toLowerCase() ===
                        countrySelected?.isoCode?.toLowerCase() &&
                    countrySelected.flag
                }
                MenuProps={{
                    className: 'syndeo-select-country-menu',
                }}
            >
                {SyndeoCountries.filter((country) => {
                    if (
                        values.readOnlyField?.includes(
                            'beautyHealthCustomerId'
                        ) ||
                        Object.keys(multiAccount).length ||
                        (unregisteredUserData &&
                            !unregisteredUserData.isNewUser)
                    ) {
                        return (
                            country.isoCode === 'US' || country.isoCode === 'CA'
                        )
                    }
                    return true
                }).map((option) => (
                    <MenuItem
                        key={`result-${option.name}`}
                        value={option.isoCode.toLowerCase()}
                        className="country-name"
                    >
                        <span>{option.flag}</span>
                        {(COUNTRY_NAMES as any)[option.isoCode]}
                    </MenuItem>
                ))}
            </Select>
        </p>
    )
}

export default AuthCountrySelection
